import React from 'react'
import { SvgIcon } from '../svg-icon.js'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing daily driving time extensions icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <DailyDrivingTimeExtensionsIcon width={12} />
 */
function DailyDrivingTimeExtensionsIcon(props) {
    return (
        <SvgIcon {...props}>
            <path
                d="M18.64,9.41c-0.56,0-1.01-0.46-1.01-1.01V6.37h-2.03c-0.56,0-1.01-0.46-1.01-1.01s0.46-1.01,1.01-1.01h2.03V2.31
            c0-0.56,0.46-1.01,1.01-1.01s1.01,0.46,1.01,1.01v2.03h2.03c0.56,0,1.01,0.46,1.01,1.01s-0.46,1.01-1.01,1.01h-2.03V8.4
            C19.65,8.96,19.2,9.41,18.64,9.41z M9,12c0,1.66,1.34,3,3,3s3-1.34,3-3s-1.34-3-3-3S9,10.34,9,12z M19.96,9.88
            c0.18,0.68,0.29,1.38,0.29,2.12c0,4.56-3.69,8.25-8.25,8.25S3.75,16.56,3.75,12S7.44,3.75,12,3.75c0.73,0,1.43,0.11,2.1,0.28
            c0.25-0.86,0.73-1.61,1.37-2.2C14.39,1.46,13.22,1.25,12,1.25C6.06,1.25,1.25,6.06,1.25,12S6.06,22.75,12,22.75
            c0.01,0,0.02,0,0.03,0c5.93-0.01,10.73-4.82,10.72-10.75c0-1.22-0.21-2.4-0.59-3.49C21.58,9.16,20.82,9.63,19.96,9.88z"
            />
        </SvgIcon>
    )
}

DailyDrivingTimeExtensionsIcon.defaultProps = defaultProps
export { DailyDrivingTimeExtensionsIcon }
